import { render } from "./FixedTimeRange.vue?vue&type=template&id=4e0a3980"
import script from "./FixedTimeRange.vue?vue&type=script&lang=ts"
export * from "./FixedTimeRange.vue?vue&type=script&lang=ts"
script.render = render

export default script